var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: "accountInfo", staticClass: "accountInfo" },
    [
      _c("header-item", { attrs: { "title-array": _vm.titleArray } }),
      _vm.$isFlag ? _c("common-navbar") : _vm._e(),
      _c(
        "div",
        { staticClass: "formClass" },
        [
          _vm.$isFlag
            ? _c("img", {
                staticClass: "imgclass",
                attrs: {
                  src: require("assets/images/accountCenter/161.png"),
                  alt: ""
                }
              })
            : _vm._e(),
          _c(
            "van-form",
            { staticClass: "info" },
            [
              _c("van-field", {
                staticClass: "infoCell",
                staticStyle: { "border-radius": "8px 8px 0 0" },
                attrs: { label: "雷霆账号:", readonly: "" },
                model: {
                  value: _vm.userInfo.username,
                  callback: function($$v) {
                    _vm.$set(_vm.userInfo, "username", $$v)
                  },
                  expression: "userInfo.username"
                }
              }),
              _c("van-field", {
                staticClass: "infoCell",
                attrs: { label: "登录密码:", readonly: "" },
                scopedSlots: _vm._u([
                  {
                    key: "button",
                    fn: function() {
                      return [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              color: "#616edf",
                              cursor: "pointer"
                            },
                            on: { click: _vm.passWordDeal }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.userInfo.isSetPwd ? "修改" : "去设置"
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.userInfo.passWordText,
                  callback: function($$v) {
                    _vm.$set(_vm.userInfo, "passWordText", $$v)
                  },
                  expression: "userInfo.passWordText"
                }
              }),
              _c("van-field", {
                staticClass: "infoCell",
                staticStyle: { height: "auto", "flex-wrap": "wrap" },
                attrs: { label: "账号安全:", readonly: "" },
                scopedSlots: _vm._u([
                  {
                    key: "button",
                    fn: function() {
                      return [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              color: "#616edf",
                              cursor: "pointer"
                            },
                            on: { click: _vm.safeManage }
                          },
                          [_vm._v(" 设置 ")]
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "extra",
                    fn: function() {
                      return [
                        _c(
                          "p",
                          {
                            staticClass: "safe-word",
                            staticStyle: { width: "100%", "text-align": "left" }
                          },
                          [
                            _vm._v(
                              "注：新设备首次账密登录时，需要通过短信校验。"
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.userInfo.safeWordText,
                  callback: function($$v) {
                    _vm.$set(_vm.userInfo, "safeWordText", $$v)
                  },
                  expression: "userInfo.safeWordText"
                }
              }),
              _c("van-cell", {
                staticClass: "cellColor infoCell",
                attrs: { title: "安全级别：" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function() {
                      return [
                        _vm.$isFlag
                          ? _c("div", { staticClass: "gradeClass" }, [
                              _c(
                                "span",
                                {
                                  style:
                                    _vm.userInfo.securityGrade == 0
                                      ? "color:#ff3d3d"
                                      : ""
                                },
                                [_vm._v("低")]
                              ),
                              _c(
                                "span",
                                {
                                  style:
                                    _vm.userInfo.securityGrade == 1
                                      ? "color:#ff9e3d"
                                      : ""
                                },
                                [_vm._v("中")]
                              ),
                              _c(
                                "span",
                                {
                                  style:
                                    _vm.userInfo.securityGrade == 2
                                      ? "color:#40bc40"
                                      : ""
                                },
                                [_vm._v("高")]
                              )
                            ])
                          : _c("div", [
                              _c("div", { staticClass: "gradeClass" }, [
                                _c("p", {
                                  style:
                                    _vm.userInfo.securityGrade == 0
                                      ? "background:#ff3d3d"
                                      : "background:#d5d7d8"
                                }),
                                _c(
                                  "span",
                                  {
                                    style:
                                      _vm.userInfo.securityGrade == 0
                                        ? "color:#ff3d3d"
                                        : "color:#d5d7d8"
                                  },
                                  [_vm._v("低")]
                                )
                              ]),
                              _c("div", { staticClass: "gradeClass" }, [
                                _c("p", {
                                  style:
                                    _vm.userInfo.securityGrade == 1
                                      ? "background:#ff9e3d"
                                      : "background:#d5d7d8"
                                }),
                                _c(
                                  "span",
                                  {
                                    style:
                                      _vm.userInfo.securityGrade == 1
                                        ? "color:#ff9e3d"
                                        : "color:#d5d7d8"
                                  },
                                  [_vm._v("中")]
                                )
                              ]),
                              _c("div", { staticClass: "gradeClass" }, [
                                _c("p", {
                                  style:
                                    _vm.userInfo.securityGrade == 2
                                      ? "background:#40bc40"
                                      : "background:#d5d7d8"
                                }),
                                _c(
                                  "span",
                                  {
                                    style:
                                      _vm.userInfo.securityGrade == 2
                                        ? "color:#40bc40"
                                        : "color:#d5d7d8"
                                  },
                                  [_vm._v("高")]
                                )
                              ])
                            ])
                      ]
                    },
                    proxy: true
                  }
                ])
              }),
              _c("div")
            ],
            1
          ),
          _c("div", { staticClass: "findThree" }, [
            _c("p", { staticClass: "auth_p" }, [_vm._v("账号认证")]),
            _c("div", { staticClass: "auth" }, [
              _c("div", { staticClass: "name" }, [
                _c("div", { staticClass: "img" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/accountCenter/light_icon_id@2" +
                        (_vm.userInfo.isBindIdentity ? "x" : "") +
                        ".png"),
                      alt: ""
                    }
                  })
                ]),
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.userInfo.isBindIdentity,
                      expression: "userInfo.isBindIdentity"
                    }
                  ],
                  staticClass: "name_rz",
                  attrs: {
                    src: require("assets/images/accountCenter/renzheng@2x.png"),
                    alt: ""
                  }
                }),
                _c("div", { staticClass: "text" }, [
                  _c(
                    "p",
                    {
                      style: _vm.userInfo.isBindIdentity ? "color:#606DE2" : ""
                    },
                    [_vm._v(" 身份认证 ")]
                  ),
                  _c("p", { staticStyle: { "font-size": "0.27rem" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.userInfo.isBindIdentity
                            ? _vm.userInfo.realName
                            : "未实名"
                        ) +
                        " "
                    )
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "btnClick" },
                  [
                    _c(
                      "van-button",
                      {
                        attrs: {
                          round: "",
                          size: "small",
                          plain: "",
                          hairline: "",
                          color: _vm.userInfo.isBindIdentity ? "#606DE2" : "red"
                        },
                        on: {
                          click: function($event) {
                            return _vm.authClick(_vm.userInfo.isBindIdentity)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.userInfo.isBindIdentity ? "查看" : "去实名"
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "name" }, [
                _c("div", { staticClass: "img" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/accountCenter/iphone" +
                        (_vm.userInfo.isBindPhone ? "" : "_default") +
                        "@2x.png")
                    }
                  })
                ]),
                _c("img", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.userInfo.isBindPhone,
                      expression: "userInfo.isBindPhone"
                    }
                  ],
                  staticClass: "name_rz",
                  attrs: {
                    src: require("assets/images/accountCenter/renzheng@2x.png"),
                    alt: ""
                  }
                }),
                _c("div", { staticClass: "text" }, [
                  _c(
                    "p",
                    { style: _vm.userInfo.isBindPhone ? "color:#606DE2" : "" },
                    [_vm._v(" 手机认证 ")]
                  ),
                  _c("p", { staticStyle: { "font-size": "0.27rem" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.userInfo.isBindPhone
                            ? _vm.userInfo.phone
                            : "未绑定"
                        ) +
                        " "
                    )
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "btnClick" },
                  [
                    _c(
                      "van-button",
                      {
                        attrs: {
                          round: "",
                          size: "small",
                          plain: "",
                          hairline: "",
                          color: _vm.userInfo.isBindPhone ? "#606DE2" : "red"
                        },
                        on: {
                          click: function($event) {
                            return _vm.goBind(_vm.userInfo.isBindPhone)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.userInfo.isBindPhone ? "修改" : "去绑定")
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ]),
            _c(
              "p",
              {
                staticStyle: {
                  color: "#eb8d12",
                  margin: "0.4rem 0 .1rem 0",
                  "font-size": "0.26rem"
                }
              },
              [_vm._v("温馨提示：")]
            ),
            _c(
              "p",
              {
                staticStyle: {
                  color: "#878787",
                  margin: "0.1rem 0",
                  "font-size": "0.24rem",
                  "line-height": "0.4rem"
                }
              },
              [
                _vm._v(
                  " 实名认证、手机认证，可以极大提高您账号的安全性，避免因账号被盗引起的巨大损失。 "
                )
              ]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }